import React from "react"
import { Box, Button, Typography, Divider } from "@mui/material"
import HpBackground from "../assets/Highland_Park_Station.jpg"
import { Link } from "react-router-dom"

const Home = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        backgroundImage: `url("${HpBackground}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Gradient overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(160deg, rgba(15,32,39,0.85), rgba(32,58,67,0.85), rgba(44,83,100,0.85))",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: { xs: "90%", md: "60%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
          py: { xs: 6, md: 10 },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: "#00e676",
            textShadow: "0 2px 12px rgba(0,0,0,0.45)",
            mb: 2,
            textAlign: "center",
            letterSpacing: 1,
          }}
        >
          Amend HP
        </Typography>
        <Divider sx={{ width: "60%", backgroundColor: "#00e676", mb: 2 }} />
        <Typography
          variant="h5"
          sx={{
            color: "white",
            fontWeight: 500,
            textAlign: "center",
            mb: 3,
            textShadow: "0 2px 8px rgba(0,0,0,0.25)",
            maxWidth: 600,
          }}
        >
          Reinvest in Highland Park’s future. Join the movement to support our streets, businesses, and community culture.
        </Typography>
        <Link to="/vault" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            color="success"
            size="large"
            sx={{
              fontWeight: 700,
              fontSize: "1.2rem",
              borderRadius: "30px",
              px: 5,
              py: 2,
              boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
              backgroundColor: "#00e676",
              color: "#000",
              "&:hover": {
                backgroundColor: "#00c853",
              },
            }}
          >
            Access Ravinia's VAULT
          </Button>
        </Link>
        <Typography
          variant="body1"
          sx={{
            color: "#fff",
            mt: 4,
            textAlign: "center",
            fontSize: "1.05rem",
            opacity: 0.85,
            maxWidth: 500,
          }}
        >
          Questions or want to get involved? <br />
          <Link to="/contact" style={{ color: "#00e676", fontWeight: 600, textDecoration: "underline" }}>
            Contact Us
          </Link>
        </Typography>
      </Box>
    </Box>
  )
}

export default Home
